import { render, staticRenderFns } from "./develop.vue?vue&type=template&id=d18d8972&scoped=true"
import script from "./develop.vue?vue&type=script&lang=js"
export * from "./develop.vue?vue&type=script&lang=js"
import style0 from "./develop.vue?vue&type=style&index=0&id=d18d8972&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18d8972",
  null
  
)

export default component.exports